import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";
import { GET_LABCLINIC_ANALYSES } from "../../services/urls";

// Admin-only catalog search for LabClinic parameters/templates.
// Backend caches the vendor catalog for 12h; never call LabClinic directly from the frontend.
export const searchLabClinicAnalyses = createAsyncThunk(
  "labclinic/searchAnalyses",
  async (
    { kind, q = "", page = 1, limit = 20, refresh = false },
    { rejectWithValue }
  ) => {
    try {
      const params = { kind };
      if (q?.trim()) params.q = q.trim();
      if (page) params.page = page;
      if (limit) params.limit = limit;
      if (refresh) params.refresh = true;
      const response = await api.get(GET_LABCLINIC_ANALYSES, { params });
      return response.data?.data ?? response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch LabClinic analyses"
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
};

const labclinicSlice = createSlice({
  name: "labclinic",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchLabClinicAnalyses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchLabClinicAnalyses.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(searchLabClinicAnalyses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default labclinicSlice.reducer;
